import React from 'react';
import WidthWrapper from '../constants/WidthWrapper';
import TopHeader from './TopHeader';
import SearchField from './SearchField';
import Overdue from './Overdue';
import NavHeader from './NavHeader';
import CatMenu from './CatMenu';
import Broadcast from './Broadcast';
import CornerCart from './CornerCart';
import SuperService from './SuperService';
import FullLine from './FullLine';
import BrandLogo from './BrandLogo';

import './index.less';

export default () => (
  <>
    <WidthWrapper className="topBar-wrapper js-topBar" fullscreen>
      <WidthWrapper>
        <TopHeader />
      </WidthWrapper>
    </WidthWrapper>
    <WidthWrapper className="header-wrapper js-header">
      <BrandLogo />
      <Broadcast />
      <div className="middle-wrapper">
        <SearchField isShow={true} />
        <Overdue />
        <div className="header-right-slot">
          <SuperService />
          <CornerCart />
        </div>
      </div>
      <CatMenu />
      <NavHeader />
    </WidthWrapper>
    <FullLine />
  </>
);
